import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'arrays_position',
    dependencies: [
        'levels/variables',
        'levels/length'
    ]
})


const randomLetter = random.unmistakableLetter



level.addQuestion({
    generator: function (q) {
        const a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addCode({
            javascript: 'let a = ' + q.codeArrayToDisplay(a) + '\na[0]',
            python:     'a = ' + q.codeArrayToDisplay(a) + '\na[0]'
        }, level.language)

        q.addBadChoices(a.length, ...a, 'digit')
    },
    timeoutTime: 15000,
    errorExpected: true,
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        let b = random.intBetween(1, a.length - 1)
        q.addCode({
            javascript: 'let a = ' + q.codeArrayToDisplay(a) + '\na[' + b + ']',
            python: 'a = ' + q.codeArrayToDisplay(a) + '\na[' + b + ']'
        }, level.language)

        q.addBadChoices(a.length, ...a, 'digit')
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = []
        let l = random.intBetween(4, 6)
        for (let i = 0; a.length < l; i++) {
            let letter = randomLetter()
            if (a.indexOf(letter) === -1) {
                a.push(letter)
            }
        }
        let b = random.intBetween(0, a.length - 1)
        q.addCode({
            javascript: 'let a = ' + q.codeArrayToDisplay(a) + "\na.indexOf('" + a[b] + "')",
            python:     'a = ' + q.codeArrayToDisplay(a) + "\na.index('" + a[b] + "')" // TODO: keyWord "index" is not colored by prism, but it seems to be normal in python
        }, level.language)

        q.addBadChoices(a.length, b, a[0], a[1], 'digit')
    },
    timeoutTime: 15000,
    errorExpected: true
})


export default level

